import React from 'react';
import { PageHead, Section, Eyebrow, PageTitle, Lede, Button } from '../components/ui';

/** The Simulator is offline while it is rebuilt. One paragraph, one next step. */
const SimulatorNoticePage = () => (
  <>
    <PageHead title="The CoThink Simulator" description="The CoThink Simulator is being rebuilt. Take the CoThink Compass in the meantime." path="/simulator" />
    <Section tone="page" reveal={false}>
      <Eyebrow>The CoThink Simulator</Eyebrow>
      <PageTitle>The Simulator is being rebuilt.</PageTitle>
      <Lede>The judgment scenarios are coming back in a new form. Until then, the Compass is the place to start: ten questions, ten minutes, and a report on where you stand across the 5Cs.</Lede>
      <div className="mt-8"><Button to="/compass">Take the Compass</Button></div>
    </Section>
  </>
);

export default SimulatorNoticePage;
